export const hasPerm = (user, perm) => {
  if (!user) return false;
  const need = Array.isArray(perm) ? perm : [perm];
  return need.some((p) => user.permissions?.includes(p));
};
